import { useFirestoreNoCompagny } from "../../firebase/useFirestore";

const TargetgroupMeta = ({targetgroupID}) => {

    const targetgroup = useFirestoreNoCompagny('Stakeholders', 'ID', targetgroupID || '')

  return (
    <p>{targetgroup[0]?.Organisation}</p>
  )
}

export default TargetgroupMeta